"use client";

import { Pagination } from "antd";
import cn from "classnames";
import { ReactNode, useMemo, useState } from "react";

import Table from "./Table";
import { TableColumnType } from "./types";

const ClientTable = ({
    caption,
    columns,
    data: fullData,
    loading,
    rowKey,
    className,
    pageSizeOptions = [10, 25, 50, 100],
    defaultPageSize = 10,
}: {
    caption?: ReactNode;
    columns?: TableColumnType[];
    readonly data?: any[];
    rowKey?: string;
    className?: string;
    loading?: boolean;
    pageSizeOptions?: number[];
    defaultPageSize?: number;
}) => {
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(defaultPageSize);
    // const [order, setOrder] = useState(null);

    const total = useMemo(() => {
        return fullData?.length;
    }, [fullData]);

    const data = useMemo(() => {
        let ordered = fullData ?? [];

        // if (order) {
        //     if (order[0] == "-") {
        //         const orderFiled = order.slice(1);
        //         ordered = fullData?.toSorted((a, b) => b[orderFiled] - a[orderFiled]) ?? [];
        //     } else {
        //         const orderFiled = order
        //         ordered = fullData?.toSorted((a, b) => a[orderFiled] - b[orderFiled]) ?? [];
        //     }
        // }

        return ordered.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize);
    }, [fullData, page, pageSize]);

    return (
        <div className={cn("flex flex-col space-y-4", className)}>
            <Table
                caption={caption}
                columns={columns}
                data={data}
                loading={loading}
                rowKey={rowKey}
                className={className}
                // order={order}
                // setOrder={setOrder}
            />
            <div className="flex justify-end">
                <div className="flex items-center space-x-4">
                    <Pagination
                        disabled={loading}
                        current={page}
                        onChange={(newPage, newPageSize) => {
                            setPageSize(newPageSize);
                            if (newPageSize !== pageSize) {
                                setPage(1);
                            } else {
                                setPage(newPage);
                            }
                            // updateData({ page: newPage, pageSize: newPageSize, search, order });
                        }}
                        pageSizeOptions={pageSizeOptions}
                        pageSize={pageSize}
                        total={total}
                    />
                    <div>Всего: {total}</div>
                </div>
            </div>
        </div>
    );
};

export default ClientTable;
